'use strict';

import domready from 'domready';
import React from 'react';
import components from './components';
import ReactDOM from 'react-dom';
import EventEmitter from 'events';
import {configureStore} from 'checkout/state';
import {lory} from 'lory.js';

if (process.env.NODE_ENV === 'production') {
    // const Raven = require('raven-js');
    // Raven.config('https://dfde63738b364c33a398ab752592a1e3@sentry.msnode.de/6', {
    //     release: window.CURRENT_RELEASE,
    //     collectWindowErrors: true,
    //     fetchContext: true,
    //     linesOfContext: 50
    // }).install();

    // window.onunhandledrejection = function(evt) {
    //     Raven.captureException(evt.reason);
    // };
}


const each = (x, f) => Array.prototype.forEach.call(x, f);
const parse = (node, x) => JSON.parse(node.getAttribute(x));
const appEmitter = new EventEmitter();

domready(() => {
    const cartStore = configureStore();
    cartStore.loadCart();

    each(document.querySelectorAll('.js_slider'), (node) => {
        lory(node, {infinite: 3});
    });

    components.forEach((component) => {
        const nodes = document.querySelectorAll(`.${component.name}`);

        each(nodes, (node) => {
            // Parse any initital data
            let state = parse(node, 'data-state') || {};
            state.eventEmitter = appEmitter;
            state.cartStore = cartStore;
            if (component.html) {
                state.html = node.innerHTML;
            }

            ReactDOM.render(React.createElement(component.module, state), node);
        });
    });
});



// WEBPACK FOOTER //
// ./static/app/boostrap.js